<div class="block-wrapper">
    <nav aria-label="quick access" i18n-aria-label="@@hermes.accessibility.quick-access" role="navigation">
        @if (skipLinks$ | async; as skipLinks) {
            <ul class="skip-links-header">
                <li id="skip-links-accessibility">
                    <a [href]="skipLinks.content" class="skip-links" i18n="@@hermes.accessibility.skip-to-content"
                        >Go to main content</a
                    >
                </li>
                <li>
                    <a
                        [href]="skipLinks.product"
                        class="skip-links"
                        [hFocus]="'#collection-button'"
                        i18n="@@hermes.accessibility.skip-to-product-navigation"
                        >Go to product browsing</a
                    >
                </li>
                @if (isCanada || isUsa) {
                    <li>
                        <a
                            [href]="skipLinks.accessibility"
                            class="skip-links"
                            i18n="@@hermes-footer-accessibility-label"
                            >Accessibility</a
                        >
                    </li>
                }
            </ul>
        }
    </nav>
</div>
